// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-view-action-template-wrapper {
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.list-view-action-template-wrapper h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.list-view-action-template-wrapper .list-content-details {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  flex-direction: column;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .img-block {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .img-block.small-img {
  height: 32px;
  width: 32px;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .img-block.medium-img {
  height: 40px;
  width: 40px;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .img-block figure {
  width: 100%;
  height: 100%;
  line-height: normal;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .img-block figure img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: fill;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .content-details {
  width: 100%;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .content-details h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .content-details p {
  color: var(--gloabl-text-desc-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-top: 8px;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .img-with-content-block .price-tag {
  flex-shrink: 0;
  color: var(--success-600, #16A34A);
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
}
.list-view-action-template-wrapper .list-content-details .list-data-temp .link-exteranl-list {
  color: var(--sdk-global-theme-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  cursor: pointer;
}
.list-view-action-template-wrapper .show-more-btn {
  padding: 8px;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.list-view-action-template-wrapper .tabs-sec-data-list-view {
  padding: 0px 10px;
  display: flex;
  gap: 8px 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.list-view-action-template-wrapper .tabs-sec-data-list-view .tab-name-list {
  border: 0;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 10px 12px;
  min-width: 44px;
  min-height: 44px;
  border-bottom: 2px solid var(--sdk-global-white-bg);
  background: var(--sdk-global-white-bg);
  transition: 0.3s all ease;
}
.list-view-action-template-wrapper .tabs-sec-data-list-view .tab-name-list:hover {
  border-bottom: 2px solid var(--sdk-global-theme-color);
}
.list-view-action-template-wrapper .tabs-sec-data-list-view .tab-name-list.active-tab {
  border-bottom: 2px solid var(--sdk-global-theme-color);
}

.menu-wrapper-data-actions {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.menu-wrapper-data-actions .actions-slider-header-menu {
  display: flex;
  align-items: center;
  padding: 14px 15px;
  gap: 10px;
  flex-shrink: 0;
}
.menu-wrapper-data-actions .actions-slider-header-menu h1 {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close {
  width: 16px;
  height: 16px;
  border: 0;
  background: transparent;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close svg path {
  fill: var(--sdk-gloabl-text-color);
}
.menu-wrapper-data-actions .iner-data-scroll-wraper {
  flex: 1 1 auto;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/listView/listView.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAEI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AAAR;AACQ;EACI,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AACZ;AAAY;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAEhB;AADgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAGpB;AAFoB;EACI,YAAA;EACA,WAAA;AAIxB;AAFoB;EACI,YAAA;EACA,WAAA;AAIxB;AAFoB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAIxB;AAHwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAK5B;AADgB;EACI,WAAA;AAGpB;AAFoB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAIxB;AAFoB;EACI,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAIxB;AADgB;EACI,cAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGpB;AAAY;EACI,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAEhB;AAGI;EACI,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AADR;AAII;EACI,iBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAFR;AAGQ;EACI,SAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,sCAAA;EACA,yBAAA;AADZ;AAEY;EACI,sDAAA;AAAhB;AAEY;EACI,sDAAA;AAAhB;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAHJ;AAII;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAFR;AAGQ;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADZ;AAGQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADZ;AAGgB;EACI,kCAAA;AADpB;AAMI;EACI,cAAA;EACA,cAAA;AAJR","sourcesContent":["\n\n.list-view-action-template-wrapper{\n    padding: 20px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    h1{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 14px;\n        font-weight: 700;\n        line-height: normal;\n    }\n    .list-content-details{\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        gap: 10px;\n        .list-data-temp{\n            border-radius: 4px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            background: var(--sdk-global-white-bg);\n            display: flex;\n            padding: 12px;\n            align-items: flex-start;\n            gap: 12px;\n            align-self: stretch;\n            flex-direction: column;\n            .img-with-content-block{\n                display: flex;\n                align-items: flex-start;\n                gap: 12px;\n                width: 100%;\n                .img-block{\n                    width: 56px;\n                    height: 56px;\n                    flex-shrink: 0;\n                    &.small-img{\n                        height: 32px;\n                        width: 32px;\n                    }\n                    &.medium-img{\n                        height: 40px;\n                        width: 40px;\n                    }\n                    figure{\n                        width: 100%;\n                        height: 100%;\n                        line-height: normal;\n                        img{\n                            width: 100%;\n                            height: 100%;\n                            border-radius: 4px;\n                            object-fit: fill;\n                        }\n                    }\n                }\n                .content-details{\n                    width: 100%;\n                    h1{\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 14px;\n                        font-weight: 700;\n                        line-height: normal;\n                    }\n                    p{\n                        color: var(--gloabl-text-desc-color);\n                        font-size: 12px;\n                        font-weight: 400;\n                        line-height: normal;\n                        margin-top: 8px;\n                    }\n                }\n                .price-tag{\n                    flex-shrink: 0;\n                    color: var(--success-600, #16A34A);\n                    font-size: 11px;\n                    font-weight: 600;\n                    line-height: 16px;\n                }\n            }\n            .link-exteranl-list{\n                color: var(--sdk-global-theme-color);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: normal;\n                text-decoration: none;\n                cursor: pointer;\n            }\n        }\n    }\n\n    .show-more-btn{\n        padding: 8px;\n        color: var(--sdk-global-theme-color);\n        text-align: center;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        border: 0;\n        background: transparent;\n        cursor: pointer;\n    }\n\n    .tabs-sec-data-list-view{\n        padding: 0px 10px;\n        display: flex;\n        gap: 8px 16px;\n        flex-wrap: wrap;\n        margin-bottom: 10px;\n        .tab-name-list{\n            border: 0;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            padding: 10px 12px;\n            min-width: 44px;\n            min-height: 44px;\n            border-bottom: 2px solid var(--sdk-global-white-bg);\n            background: var(--sdk-global-white-bg);\n            transition: 0.3s all ease;\n            &:hover{\n                border-bottom: 2px solid var(--sdk-global-theme-color);\n            }\n            &.active-tab{\n                border-bottom: 2px solid var(--sdk-global-theme-color);\n            }\n        }\n    }\n}\n\n.menu-wrapper-data-actions{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    .actions-slider-header-menu{\n        display: flex;\n        align-items: center;\n        padding: 14px 15px;\n        gap: 10px;\n        flex-shrink: 0;\n        h1{\n            width: 100%;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n        }\n        .menu-close{\n            width: 16px;\n            height: 16px;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            svg{\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n    .iner-data-scroll-wraper{\n        flex: 1 1 auto;\n        overflow: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
